<template>
  <div class="m-widget" :class="data.renk">
    <i :class="data.icon"></i>
    <div class="m-icerik">
      <h4 v-html="data.sayi"></h4>
      <h5 v-html="data.isim"></h5>
    </div>
  </div>
</template>

<script>
    export default {
        props:["data"]
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pack/Genel/mWidget.vue